import React, { createContext, useState } from "react";
import { authHttp } from "../services/commonHttpService";

// Create Context
const CommonContext = createContext({});

const CommonProvider = ({ children }) => {
    // Loading state
    const [isLoading, setIsLoading] = useState(false);

    // Alert state
    const [alertState, setAlertState] = useState({
        open: false,
        title: '',
        message: '',
        btnTxt: 'OK',
        cancelBtnTxt: 'No',
        status: 'success', // 'success', 'error', 'warning', 'info'
        type: 'alert', // 'alert' or 'confirm'
        onClose: null, // Optional callback function to execute when alert closes
        onConfirm: null, // Optional callback function to execute when user confirms (for type='confirm')
    });

    // Snack Alert state
    const [snackState, setSnackState] = useState({
        open: false,
        message: '',
        severity: 'success', // 'success' or 'error'
    });

    // Master data state
    const [masterData, setMasterData] = useState({});

    // Fetch master data from API
    const getMasterData = async (path, masterType) => {
        setIsLoading(true);
        try {
            const response = await authHttp.get(path);

            if (response?.data?.data) {
                setMasterData((previousState) => ({
                    ...previousState,
                    [masterType]: response?.data?.data,
                }));
                return response.data.data;
            }
        } catch (error) {
            setSnackState({
                open: true,
                message: error?.response?.data?.msg,
                severity: 'error',
            });
            // throw error;
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <CommonContext.Provider
            value={{
                // Loading state
                isLoading,
                setIsLoading,

                // Alert state
                alertState,
                setAlertState,

                // Master data
                masterData,
                setMasterData,
                getMasterData,

                // Snack state
                snackState,
                setSnackState,
            }}
        >
            {children}
        </CommonContext.Provider>
    );
};

export { CommonContext, CommonProvider };